import React from 'react';
import { formatCash, formatDate } from '../../../../../utils/sharedFunctions';
import { TextInputDropdown, TextInput } from '../../../../../components';
import { MenuItem } from "@mui/material";
const downArrow = `${process.env.REACT_APP_CDN_URL}/globalAssets/briefview/downArrow.svg`;

const FinanceTab = ({
    IsInfoEdit,
    SelectedBrief,
    handleFeeChange,
    handleStatusChange,
    handleFulfilmentStageChange,
    handleMilestoneChange,
    handleProjectPaymentChange
}) => {
    return IsInfoEdit ? (
        <div className='BriefFinanceTabSect'>
            <div className='financeDetailsContainer' style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
                <TextInput 
                    style={{ width: '33%', marginRight: '1%' }} 
                    label='Total Project Cost' 
                    placeholder='Total Project Cost' 
                    id='TotalCost' 
                    onChange={handleFeeChange} 
                    type='number' 
                    value={SelectedBrief?.budgetEstimation ?? 0}
                />
                <TextInput 
                    style={{ width: '33%', marginRight: '1%' }} 
                    label='Credipple Fee' 
                    placeholder='Credipple Fee' 
                    id='CredippleFee' 
                    type='number' 
                    value={SelectedBrief.budgetEstimation === undefined ? 0 : Number(SelectedBrief.budgetEstimation * 0.10 || 0).toFixed(2)}
                />
                <TextInput 
                    style={{ width: '33%', marginRight: '1%' }} 
                    label='Service Provider Fee' 
                    placeholder='Service Provider Fee' 
                    id='ServiceFee' 
                    type='number' 
                    value={SelectedBrief.budgetEstimation === undefined ? 0 : (Number(SelectedBrief.budgetEstimation)).toFixed(2)}
                />
            </div>
            
            <div className='financeDetailsContainer' style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
                <TextInputDropdown 
                    style={{ width: '33%', marginRight: '1%' }} 
                    label='Job Status' 
                    placeholder='Job Status' 
                    id='JobStatus' 
                    value={SelectedBrief.briefStatus} 
                    onChange={handleStatusChange}
                >
                    <MenuItem value='Not Started'>Not Started</MenuItem>
                    <MenuItem value='approved'>approved</MenuItem>
                    <MenuItem value='In Progress'>In Progress</MenuItem>
                    <MenuItem value='Completed'>Completed</MenuItem>
                    <MenuItem value='On Hold'>On Hold</MenuItem>
                    <MenuItem value='Cancelled'>Cancelled</MenuItem>
                </TextInputDropdown>
                
                <TextInputDropdown 
                    style={{ width: '33%', marginRight: '1%' }} 
                    label='Fulfillment Stage' 
                    placeholder='Fulfillment Stage' 
                    value={SelectedBrief?.projectPlan[0]?.fulfillmentStage || ''} 
                    onChange={handleFulfilmentStageChange}
                >
                    <MenuItem value='Brief'>Brief</MenuItem>
                    <MenuItem value='Quote and Project Plan'>Quote and Project Plan</MenuItem>
                    <MenuItem value='Deposit Invoice'>Deposit Invoice</MenuItem>
                    <MenuItem value='Contracting'>Contracting</MenuItem>
                    <MenuItem value='Project in Progress'>Project in Progress</MenuItem>
                    <MenuItem value='Milestone Payment'>Milestone Payment</MenuItem>
                    <MenuItem value='Professional Evaulation'>Professional Evaulation</MenuItem>
                    <MenuItem value='Final Payment'>Final Payment</MenuItem>
                    <MenuItem value='Project Closed'>Project Closed</MenuItem>
                </TextInputDropdown>
                
                <TextInputDropdown 
                    style={{ width: '33%', marginRight: '1%' }} 
                    label='Payment Milestone Number' 
                    placeholder='Payment Milestone Number' 
                    value={SelectedBrief?.quote?.[0]?.milestone || SelectedBrief?.brief?.quote?.[0]?.milestone || ''} 
                    onChange={handleMilestoneChange}
                >
                    <MenuItem value='Milestone 1 of 1'>Milestone 1 of 1</MenuItem>
                    <MenuItem value='Milestone 1 of 2'>Milestone 1 of 2</MenuItem>
                    <MenuItem value='Milestone 2 of 2'>Milestone 2 of 2</MenuItem>
                    <MenuItem value='Milestone 1 of 3'>Milestone 1 of 3</MenuItem>
                    <MenuItem value='Milestone 2 of 3'>Milestone 2 of 3</MenuItem>
                    <MenuItem value='Milestone 3 of 3'>Milestone 3 of 3</MenuItem>
                    <MenuItem value='Monthly Retainer'>Monthly Retainer</MenuItem>
                </TextInputDropdown>
            </div>
            
            <div className='projectPaymentsSection'>
                <p className='header'>Project Payments</p>
                <div className='invoiceSection'>
                    <div className='invoiceheaderSect'>
                        <p style={{ width: '20%' }}>Invoice Number</p>
                        <p style={{ width: '20%' }}>Date</p>
                        <p style={{ width: '20%' }}>Payment Method</p>
                        <p style={{ width: '20%' }}>PO Number</p>
                        <p style={{ width: '20%' }}>Voucher Code</p>
                        <p style={{ width: '20%' }}>Amount</p>
                    </div>
                    <div className='availInvoiceContainer'>
                        {Object.keys(SelectedBrief).includes('payments') ? (
                            SelectedBrief.payments.invoiceNumbers?.map((item, index) => (
                                <div className='availCard' key={index}>
                                    <TextInput 
                                        value={item || ''} 
                                        id='invoice' 
                                        key={index} 
                                        placeholder={'TYC0456'} 
                                        style={{ width: '16.67%' }} 
                                        onChange={(e) => handleProjectPaymentChange(e, index)} 
                                    />
                                    <TextInput 
                                        type='date' 
                                        value={formatDate(SelectedBrief?.payments?.previousPayments[index]?.date ?? '')} 
                                        id='date' 
                                        placeholder={'yyyy/mm/dd'} 
                                        style={{ width: '16.67%' }} 
                                        onChange={(e) => handleProjectPaymentChange(e, index)} 
                                    />
                                    <p style={{ width: '16.67%' }}>{SelectedBrief.paymentMethod ?? ''}</p>
                                    <TextInput 
                                        value={SelectedBrief?.payments?.purchaseOrderNumber ?? ''} 
                                        id='poNumber' 
                                        placeholder={'12P3456O789'} 
                                        style={{ width: '16.67%' }} 
                                        onChange={(e) => handleProjectPaymentChange(e, index)} 
                                    />
                                    <TextInput 
                                        value={SelectedBrief.payments?.voucherId ?? ''} 
                                        id='voucher' 
                                        placeholder={'#5YB5GD5TE'} 
                                        style={{ width: '16.67%' }} 
                                        onChange={(e) => handleProjectPaymentChange(e, index)} 
                                    />
                                    <TextInput 
                                        value={SelectedBrief?.payments?.previousPayments[index]?.amount ?? 0} 
                                        id='amnt' 
                                        placeholder={'ZAR 1 000 000,00'} 
                                        style={{ width: '16.67%' }} 
                                        onChange={(e) => handleProjectPaymentChange(e, index)} 
                                    />
                                </div>
                            ))
                        ) : Object.keys(SelectedBrief).includes('project') && Object.keys(SelectedBrief.project).includes('payments') ? null : null}
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className='BriefFinanceTabSect'>
            <div className='financeDetailsContainer'>
                <span className='availFinanceDetailsSect'>
                    <p className='header'>Total Project Cost</p>
                    <p className='value'>
                        {`ZAR-${formatCash(Number(SelectedBrief?.budgetEstimation) + Number(SelectedBrief?.budgetEstimation * 0.10) ?? 0)}`}
                    </p>
                </span>
                <span className='availFinanceDetailsSect'>
                    <p className='header'>Credipple Fee</p>
                    <p className='value'>{`ZAR-${SelectedBrief?.budgetEstimation !== null && SelectedBrief.budgetEstimation !== undefined ? formatCash(SelectedBrief.budgetEstimation * 0.10) : '0.00'}`}</p>
                </span>
                <span className='availFinanceDetailsSect'>
                    <p className='header'>Service Provider Fee</p>
                    <p className='value'>{`ZAR-${SelectedBrief?.budgetEstimation !== null && SelectedBrief.budgetEstimation !== undefined ? formatCash(Number(SelectedBrief.budgetEstimation)) : '0.00'}`}</p>
                </span>
            </div>
            
            <div className='financeDetailsContainer'>
                <span className='availFinanceDetailsSect'>
                    <p className='header'>Job Status</p>
                    <div className='briefStageSect'>
                        <p>{SelectedBrief?.briefStatus || SelectedBrief?.status || ''}</p>
                        <img src={downArrow} alt='' />
                    </div>
                </span>
                <span className='availFinanceDetailsSect'>
                    <p className='header'>Fulfillment Stage</p>
                    <div className='briefStageSect'>
                        <p>{SelectedBrief.projectPlan[0] ? SelectedBrief.projectPlan[0].fulfillmentStage || 'Not Assigned' : 'Unknown'}</p>
                        <img src={downArrow} alt='' />
                    </div>
                </span>
                <span className='availFinanceDetailsSect'>
                    <p className='header'>Payment Milestone</p>
                    <div className='briefStageSect'>
                        {Object.keys(SelectedBrief).includes('quote') ?
                            Array.isArray(SelectedBrief.quote) && SelectedBrief.quote.length > 0 ?
                                typeof SelectedBrief.quote[0] === 'object' ?
                                    <p>{SelectedBrief?.quote[0]?.milestone ?? ''}</p>
                                    : ''
                                : ''
                            : Object.keys(SelectedBrief).includes('brief') ?
                                Array.isArray(SelectedBrief.brief.quote) && SelectedBrief.brief.quote.length > 0 ?
                                    typeof SelectedBrief.brief.quote[0] === 'object' ?
                                        <p>{SelectedBrief?.brief.quote[0]?.milestone ?? ''}</p>
                                        : ''
                                    : ''
                                : ''
                        }
                        <img src={downArrow} alt='' />
                    </div>
                </span>
            </div>
            
            <div className='projectPaymentsSection'>
                <p className='header'>Project Payments</p>
                <div className='invoiceSection'>
                    <div className='invoiceheaderSect'>
                        <p style={{ width: '16.67%' }}>Invoice Number</p>
                        <p style={{ width: '16.67%' }}>Date</p>
                        <p style={{ width: '16.67%' }}>Payment Method</p>
                        <p style={{ width: '16.67%' }}>PO Number</p>
                        <p style={{ width: '16.67%' }}>Voucher Code</p>
                        <p style={{ width: '16.67%' }}>Amount</p>
                    </div>
                    <div className='availInvoiceContainer'>
                        {Object.keys(SelectedBrief).includes('payments') ? (
                            SelectedBrief.payments.invoiceNumbers?.map((item, index) => (
                                <div className='availCard' key={index}>
                                    <p style={{ width: '16.67%' }}>{item}</p>
                                    <p style={{ width: '16.67%' }}>{formatDate(SelectedBrief?.payments?.previousPayments[index]?.date ?? '')}</p>
                                    <p style={{ width: '16.67%' }}></p>
                                    <p style={{ width: '16.67%' }}>{SelectedBrief.payments.purchaseOrderNumber ?? ''}</p>
                                    <p style={{ width: '16.67%' }}>{SelectedBrief.payments?.voucherId ?? ''}</p>
                                    <p style={{ width: '16.67%' }}>{`ZAR-${formatCash(SelectedBrief?.payments?.previousPayments[index]?.amount) ?? ''}`}</p>
                                </div>
                            ))
                        ) : Object.keys(SelectedBrief).includes('project') && Object.keys(SelectedBrief.project).includes('payments') ? null : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinanceTab;